import { memo } from "react";

import { Button } from "../button/Button";
import { useDialogModal } from "./DialogModal";

export const DialogModalClose = memo(function DialogModalClose() {
  const { requestClose } = useDialogModal();

  return (
    <div className="DialogModalClose">
      <Button
        size="xs"
        shape="circle"
        appearance="minimal"
        icon={"xmark"}
        onClick={requestClose}
      />
    </div>
  );
});
